export default "__VITE_ASSET__270116bb__"